export default {
    // Source of Thruth for all reconciliation page
    state: {
        // Build from listingV2 backend. Contains obj with
        // docid, thirdname, ident, displayedDate, step, 
        // totalAmount and dueAmount
        docs : [],
        // Display loader during document fetch 
        loadingDocs : false,
        // Build from listingV2 backend. Contains
        // current_page, last_page, per_page and total
        pagination : {
            per_page: 25,
        },
        // To process and for the summary panel. Contains obj with
        // docid, paymentid or paymentAmount + payment ref and deadlineId.
        // Need also a unique id to delete a reconciliation directly
        reconciled : [],
        // current doctype for doc listing
        doctype : null,
        // current transaction date
        transactionDate : null,
        // current transaction amount
        transactionAmount: 0,
        transactionReconciledAmount:0,
        transactionRemainingReconciledAmount: 0,
        transactionType: null,
        transactionCurrencySymbol: null,

        doctypesDirection : {
            "invoice":"credit",
            "creditnote":"debit",
            "purInvoice":"debit",
            "purCreditNote":"credit",
        }
    },
    setDocs (docs) {
        this.state.docs = docs
    },
    docsLoading () {
        this.state.loadingDocs = true;
    },
    docsLoaded () {
        this.state.loadingDocs = false;
    },
    setPagination (pagination){
        this.state.pagination = pagination
    },
    addReconciled (reconciliation){
        this.state.reconciled.push(reconciliation)
    },
    delReconciled (id){
        this.state.reconciled = this.state.reconciled.filter(reconciled => {
            return reconciled.id != id
        });
    },
    setDoctype (doctype) {
        this.state.doctype = doctype
    },
    setTransactionId(transactionId){
        this.state.transactionId = transactionId
    },
    setTransactionDate(transactionDate){
        this.state.transactionDate = transactionDate
    },
    setTransactionAmount(transactionAmount){
        this.state.transactionAmount = transactionAmount
    },
    setTransactionReconciledAmount(transactionReconciledAmount){
        this.state.transactionReconciledAmount = transactionReconciledAmount
    },
    setTransactionRemainingReconciledAmount(transactionRemainingReconciledAmount){
        this.state.transactionRemainingReconciledAmount = transactionRemainingReconciledAmount
    },
    setTransactionType(transactionType){
        this.state.transactionType = transactionType
    },
    setTransactionCurrencySymbol(currencySymbol){
        this.state.transactionCurrencySymbol = currencySymbol
    }
}